// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"5":"de64ab6b","453":"0e84fa6c","455":"45fdf976","806":"2295ccc6","977":"ccb444a6"}[chunkId] + ".chunk.js";
};